module.exports = __webpack_public_path__ + "static/love-henri-cdf05d0759196b287ca4cb4bce07ec58.jpg";